









































































import { mapActions, mapState } from 'vuex';
import { cloneDeep } from 'lodash-es';

// Components
import AssetsCard from '@adobe/edex/frontend/views/course/settings/course-settings-assets.vue';
import SettingsCard from '@adobe/edex/frontend/views/course/settings/course-settings-basic.vue';
import SeoCard from '@adobe/edex/frontend/views/course/settings/course-settings-seo.vue';
import CompletionCard from '@adobe/edex/frontend/views/course/settings/course-settings-completion-behavior.vue';
import DatesCard from '@adobe/edex/frontend/views/course/settings/course-settings-dates.vue';
import EducatorsCard from '@adobe/edex/frontend/views/course/settings/course-settings-educators.vue';
import Sidebar from '@adobe/edex/frontend/views/course/settings/course-settings-sidebar.vue';
import {
  buildPayload,
  ChangeLogType,
  BasePayloadType,
  getDefaultAssetsPayload,
} from '@adobe/edex/frontend/views/course/settings/constants';

import * as courseAPI from '@adobe/edex/frontend/api/course';

const CHILDREN_REVERT_LENGTH = 6;
export default {
  data() {
    return {
      diffMap: {},
      hasDiffs: false,
      revertAll: false,
      childrenReverted: 0,
      loading: false,
      error: false,
    };
  },
  components: {
    AssetsCard,
    SettingsCard,
    SeoCard,
    CompletionCard,
    DatesCard,
    EducatorsCard,
    Sidebar,
  },
  computed: {
    ...mapState('course', ['course', 'instructors', 'staff']),
    ...mapState('member', ['member']),
    educatorsLoading() {
      return !this.instructors || !this.staff;
    },
  },
  async created() {
    this.checkPermissions();
    if (!this.instructors || !this.staff) {
      await this.getCourseEducators(this.course.id);
    }
  },
  beforeRouteEnter(_, __, next) {
    return next((vm: any) => {
      vm.checkPermissions();
    });
  },
  watch: {
    async childrenReverted(current) {
      if (this.revertAll && current == CHILDREN_REVERT_LENGTH) {
        this.diffMap = {};
        this.hasDiffs = false;
        this.revertAll = false;
        this.childrenReverted = 0;
        if (!this.instructors || !this.staff) {
          await this.getCourseEducators(this.course.id);
        }
      }
    },
  },
  methods: {
    ...mapActions('course', ['getCourseEducators', 'updateCourse']),
    onChange(changeLog: ChangeLogType) {
      this.diffMap[changeLog.name] = changeLog;
      const newDiffs = this.checkDiffs();
      if (newDiffs != this.hasDiffs) {
        this.hasDiffs = newDiffs;
      }
    },
    checkPermissions() {
      // R E D I R E C T   N O N - A D M I N   T O   A B O U T
      // Doesn't allow non-admins to navigate to settings page
      if (!this.member?.isAdmin) {
        this.$router.push(
          this.rDecor({
            name: 'course-about',
            params: {
              vanityURL: this.course.vanityURL,
            },
          })
        );
      }
    },
    checkDiffs() {
      return Object.values(this.diffMap)
        .map((changeLog: ChangeLogType) => changeLog.hasDiff)
        .some(Boolean);
    },
    onRevertAllHandled() {
      this.childrenReverted = this.childrenReverted + 1;
    },
    async submitCourseUpdates() {
      this.loading = true;
      const changeLogs = Object.values(this.diffMap) as ChangeLogType[];
      const basePayload = {
        assets: getDefaultAssetsPayload(this.course.assets),
        settings: cloneDeep(this.course.settings),
        educators: cloneDeep(this.course.educators),
      } as BasePayloadType;
      const payload = buildPayload(changeLogs, basePayload);
      try {
        const { data } = await courseAPI.updateCourse(this.course.id, payload);
        this.updateCourse(data);
        this.revertAll = true;
      } catch (e) {
        console.log('UPDATE ERROR: ', e);
      }
      this.loading = false;
    },
  },
};
